import { jsx as _jsx } from "react/jsx-runtime";
export var Welcome = function () {
    return (
    // TODO: update welcome text
    _jsx("p", { children: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo quo, sed eveniet sit cum ullam esse provident modi odit dignissimos nam veritatis sapiente eius unde possimus debitis dicta error quaerat!" }));
};
